/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import classes from "./ModalPixWaitPayment.module.scss";
import modalCloseButton from "./../../../../../../../assets/images/onboarding/modal_close_button.svg";
import afinandoStartTour from "./../../../../../../../assets/images/smartphone_and_lupa.svg";

const ModalPixWaitPayment = ({
  openModalWaitPayment,
  setOpenModalWaitPayment,
}) => {
  const [content, setContent] = useState(true);

  useEffect(() => {
    setContent(
      openModalWaitPayment ? (
        <div className={classes.WrapModal}>
          <div className={classes.ModalDefault}>
            <div className={classes.ModalDefaultTop}>
              <div className={classes.Title}>{"Aguardando confirmação"}</div>
              <button
                className={classes.ButtonClose}
                onClick={() => {
                  setOpenModalWaitPayment(false);
                }}
              >
                <img src={modalCloseButton} alt="close button" />
              </button>
            </div>
            <div className={classes.ModalDefaultBottom}>
              <div className={classes.ModalTextArea}>
                Não conseguimos reconhecer seu pagamento.
              </div>
              <div className={classes.ModalTextArea}>
                Se você já realizou o pagamento via Pix, aguarde alguns
                instantes enquanto processamos. Caso contrário, finalize o
                pagamento para concluir sua compra.
              </div>
              <img src={afinandoStartTour} alt="close button" />
              <button
                onClick={() => {
                  setOpenModalWaitPayment(false);
                }}
                className={classes.ButtonStartTour}
              >
                Entendi
              </button>
            </div>
          </div>
        </div>
      ) : null
    );
  }, [openModalWaitPayment, setOpenModalWaitPayment]);

  return content;
};
export default ModalPixWaitPayment;
